var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('van-calendar',{attrs:{"type":_vm.type,"color":_vm.color,"min-date":_vm.minDateFormat,"max-date":_vm.maxDateFormat},on:{"closed":_vm.close,"confirm":_vm.onConfirm},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }